import axios, { type AxiosError, type AxiosInstance, type AxiosResponse } from 'axios'
import router from '@/router'
import { getProjectConfig } from '@/shared/projectEnvVariables.ts'
import { useAuthStore } from '@/stores/auth.ts'

export function onResponse (response: AxiosResponse) {
  return response
}

export async function onResponseError (error: AxiosError) {
  if (error?.response?.status == 401 && router.currentRoute.value.name !== 'login') {
    await router.push({
      name: 'login',
      query: { redirect: router.currentRoute.value.fullPath },
    })
  }
  throw error
}

const axiosDefault = {
  baseURL: getProjectConfig().VITE_API_BASE_URL,
}

export const axiosAPI: AxiosInstance = axios.create(axiosDefault)

axiosAPI.interceptors.response.use(onResponse, onResponseError)
axiosAPI.interceptors.request.use(config => {
  const authStore = useAuthStore()
  const token = authStore.sessionToken

  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
})
